import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { PickingsList } from "pages/wms/pickingsList/PickingsList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const Pickings = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={PickingsList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - WMS - pickingi"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
